const ClosureNotice = () => {
  return (
    <div className="fixed top-0 w-full z-50 bg-gradient-to-r from-red-900 via-red-800 to-red-900 text-white border-b-2 border-red-700 shadow-lg">
      <div className="container-custom py-2 px-4 text-center text-xs sm:text-sm md:text-base font-medium leading-tight">
        <span className="font-bold tracking-wide uppercase mr-2">
          Permanently Closed
        </span>
        <span className="hidden sm:inline">
          &mdash; Colorado First Plumbing and Sewer LLC closed in March 2026. Thank you, Colorado, for 8 incredible years.
        </span>
        <span className="sm:hidden">
          &mdash; Closed March 2026. Thank you, Colorado.
        </span>
      </div>
    </div>
  );
};

export default ClosureNotice;
